import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import autoTable from 'jspdf-autotable';
import jsPDF from "jspdf";
import moment from "moment";
import React, { useState, useEffect } from 'react'

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";

import { callAddFontNirmalaBold } from '../../../styles/fonts/Nirmala-bold';
import { callAddFontNirmalaNormal } from '../../../styles/fonts/Nirmala-normal';
import { excelConfig, filterHeaderXlStyle, filterHeaderXlDataStyle } from '../../../configs/excelConfig';
import { fetchApi } from '../../../services/apiService';
import { hasAccess, jsPdfHeaderFooter, jsPdfDidParseCellCallback, jsPdfWillDrawCellCallback } from '../../../components/generics/helper';
import { Loader } from '../../../components/generics/Loader';
import CommonTableBody from "../../../components/Table/CommonTableBody";
import CommonTableHeaderRow from '../../../components/Table/CommonTableHeaderRow';
import excelExport from '../../../services/exports/export-excel';

const SrNoWiseItemHistoryList = (props) => {
    const { srNoWiseItemHistoryFilters, loadData, setLoadData } = props
    const { enqueueSnackbar } = useSnackbar();

    const { selectedRolesRights = [], adminType = 0 } = useSelector((state) => state.login?.userData);
    const userToken = useSelector((state) => state.login.userToken);
    const userData = useSelector((state) => state.login.userData);

    const [isPdfLoading, setIsPdfLoading] = useState(false);
    const [isPdfLoaded, setIsPdfLoaded] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getSrNoWiseItemHistoryParams = (filters) => {
        let params = {};
        if (filters?.searchItemId !== '') {
            params = { ...params, searchItemId: filters?.searchItemId };
        }
        if (filters?.searchSerialNo !== '') {
            params = { ...params, searchSerialNo: filters?.searchSerialNo };
        }
        return params;
    };


    const generateSrNoWiseItemHistoryData = async () => {
        setIsLoading(true);
        try {
            const searchParams = getSrNoWiseItemHistoryParams(srNoWiseItemHistoryFilters);

            const response = await fetchApi('reports/getSerialNoWiseHistoryData', searchParams, userToken);
            setIsLoading(false);

            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                if (response.data.serialNoWiseItemHistory.length > 0) {
                    enqueueSnackbar('Sr No Wise Item History Data Loaded Successfully', { variant: 'success', key: Date.now() });
                    setTableData(response?.data?.serialNoWiseItemHistory);
                } else {
                    enqueueSnackbar('Ooops! No Record Found', { variant: 'error' });
                    setTableData([]);
                }
            } else {
                enqueueSnackbar(response.errorMessage, { variant: 'error' });
                setTableData([]);
            }
        } catch (err) {
            let message = 'Sr No Wise Item History List Loading Failed';
            if (!err.message) {
                err.message = message
            }
            enqueueSnackbar(err.message, { variant: 'error' });
            setTableData([])
        } finally {
            setLoadData(false);
        }
    }
    const columnDefs = [
        { headerName: 'Date', pdfHead: 'Date', field: 'trDate', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: "120px", textAlign: 'left' }, allowSorting: false },
        { headerName: 'Time', pdfHead: 'Time', field: 'trTime', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '80px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Transaction Type', pdfHead: 'TXn. Type', xlCol: { dataType: 'string', dataFormatter: null, width: 40 }, field: 'trTypeName', headerSx: { width: '200px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Condition', pdfHead: 'Condition', xlCol: { dataType: 'string', dataFormatter: null, width: 30 }, field: 'dismountCondition', headerSx: { width: '100px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Bus Number', pdfHead: 'Bus Number', field: 'vehicleNo', xlCol: { dataType: 'string', dataFormatter: null, width: 40 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Bus Code', pdfHead: 'Bus Code', field: 'vehicleCode', xlCol: { dataType: 'string', dataFormatter: null, width: 40 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },        
        { headerName: 'Reference Number', pdfHead: 'Reference Number', field: 'refNo', xlCol: { dataType: 'string', dataFormatter: null, width: 40 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Position', pdfHead: 'Position', field: 'position', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { width: '80px', textAlign: "left" }, allowSorting: false },
        { headerName: 'User', pdfHead: 'User', field: 'trByUser', xlCol: { dataType: 'string', dataFormatter: null, width: 30 }, headerSx: { width: '120px', textAlign: "left" }, allowSorting: false },
        { headerName: 'Bus Odometer', pdfHead: 'Bus Odometer', field: 'km', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, headerSx: { width: '100px', textAlign: "right" }, allowSorting: false },
        { headerName: 'Part KM', pdfHead: 'Part KM', field: 'partKM', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, headerSx: { width: '100px', textAlign: "right" }, allowSorting: false },
        { headerName: 'After Repair', pdfHead: 'After Repair', field: 'repairKM', xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, headerSx: { width: '100px', textAlign: "right" }, allowSorting: false },
    ];
    const getFilterSectionData = () => {
        return {
            filterHeaderXlStyle,
            filterHeaderXlDataStyle,
            filterData: [
                {
                    columns: [
                        { header: 'Bus OEM', dataKey: 'vehicleOemName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: 'Bus Model Num', dataKey: 'vehicleModelName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: 'Category', dataKey: 'categoryTitle', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 1 } },
                        { header: 'Subcategory', dataKey: 'subCategoryTitle', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: 'Brand', dataKey: 'brandName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 1 } },
                        { header: 'Items', dataKey: 'itemName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
                        { header: 'Sr No', dataKey: 'serialNo', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 1 } },
                    ],
                    pdfColumnStyles: {
                        0: { cellWidth: 31, halign: 'left', fontSize: 10 },
                        1: { cellWidth: 50, halign: 'left', fontSize: 10 },
                        2: { cellWidth: 40, halign: 'left', fontSize: 10 },
                        3: { cellWidth: 40, halign: 'left', fontSize: 10 },
                        4: { cellWidth: 31, halign: 'left', fontSize: 10 },
                        5: { cellWidth: 55, halign: 'left', fontSize: 10 },
                        6: { cellWidth: 40, halign: 'left', fontSize: 10 },
                    },
                    data: [
                        {
                            vehicleOemName: srNoWiseItemHistoryFilters.searchVehBrandId === "" ? 'All Vehicle OEM' : srNoWiseItemHistoryFilters?.searchVehBrandName,
                            vehicleModelName: srNoWiseItemHistoryFilters.searchVehModelId === "" ? 'All Vehicle Models' : srNoWiseItemHistoryFilters?.searchVehModelName,
                            categoryTitle: srNoWiseItemHistoryFilters.searchCategoryId === "" ? 'All Categories' : srNoWiseItemHistoryFilters?.searchCategoryName,
                            subCategoryTitle: srNoWiseItemHistoryFilters.searchSubCategoryId === "" ? 'All Sub Categories' : srNoWiseItemHistoryFilters?.searchSubCategoryName,
                            brandName: srNoWiseItemHistoryFilters.searchBrandId === "" ? 'All Brands' : srNoWiseItemHistoryFilters?.searchBrandName,
                            itemName: srNoWiseItemHistoryFilters?.searchItemName,
                            serialNo: srNoWiseItemHistoryFilters?.searchSerialNo,
                        }
                    ]
                },
            ]
        }
    }
    const printReport = async () => {
        try {
            const filterSectionData = getFilterSectionData();
            setIsPdfLoading(true);
            setIsPdfLoaded(false);
            const pdfColumns = columnDefs.map((col) => {
                return { header: col.pdfHead, dataKey: col.field, xlCol: col.xlCol }
            });

            jsPDF.API.events.push(["addFonts", callAddFontNirmalaBold]);
            jsPDF.API.events.push(["addFonts", callAddFontNirmalaNormal]);
            const doc = new jsPDF({
                orientation: 'l',
                format: 'a4',
                compress: true,
            });
            var totalPagesExp = '{total_pages_count_string}';
            doc.autoTableSetDefaults({
                headStyles: { fontSize: 6, halign: 'left', fillColor: [30, 89, 167] },
            });
            doc.setProperties({
                title: `srNoWiseItemHistoryReport-${moment().format('DD-MMM-YY-HH-mm')}.pdf`,
                subject: "S/r No Wise Item History Report",
                author: "Maven Tech Labs Pvt. Ltd.",
                keywords: "maven tech, Maintenance system, Sr No Wise Item History Report",
                creator: "MTLPL",
            });
            autoTable(doc, {
                margin: { top: 16, left: 5, right: 5, bottom: 5 },
                columns: filterSectionData.filterData[0].columns,
                body: filterSectionData.filterData[0].data,
                columnStyles: filterSectionData.filterData[0].pdfColumnStyles,
                theme: 'grid',
                tableWidth: 'wrap',
            });
            doc.line(0, doc.lastAutoTable.finalY + 2, doc.getPageWidth(), doc.lastAutoTable.finalY + 2);
            autoTable(doc, {
                startY: doc.lastAutoTable.finalY + 4,
                tableWidth: 'auto',
                margin: { top: 2, left: 5, right: 5, bottom: 5 },
                alternateRowStyles: {
                    fillColor: [255, 255, 255]
                },
                columns: pdfColumns,
                body: tableData,

                columnStyles: {
                    0: { minCellWidth: 15 },
                    1: { minCellWidth: 15 },
                    2: { minCellWidth: 12 },
                    3: { minCellWidth: 15 },
                    4: { minCellWidth: 12 },
                    5: { minCellWidth: 12 },
                    6: { minCellWidth: 12 },
                    7: { minCellWidth: 12 },
                    8: { minCellWidth: 12 },
                    9: { minCellWidth: 12, halign: 'right' },
                    10: { minCellWidth: 12, halign: 'right' },
                    11: { minCellWidth: 12, halign: 'right' },
                },
                theme: 'grid',
                bodyStyles: {
                    fontSize: 6,
                    halign: 'left',
                },
                didParseCell: (data) => {
                    jsPdfDidParseCellCallback(data, pdfColumns,);
                },
                willDrawCell: (data) => {
                    jsPdfWillDrawCellCallback(data);
                },
                didDrawPage: function (data) {
                    data.settings.margin.top = 16;
                    const reportTitle = `Maintenance System | S/r No Wise Item History Report`;
                    jsPdfHeaderFooter(data, reportTitle, userData, totalPagesExp);
                },
            },
            );
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp)
            }
            setIsPdfLoaded(true);
            setTimeout(() => {
                // document.getElementById('output').data = doc.output('datauristring', `srNoWiseItemHistory_${moment(new Date()).format("DD_MMM_YYYY_ddd_HH_mm")}.pdf`);
                const blob = doc.output('blob');
                const url = URL.createObjectURL(blob);
                document.getElementById('output').data = url;
                setIsPdfLoading(false);
            }, 1000);
        } catch (err) {
            console.log(err);
            setIsPdfLoading(false);
            setIsPdfLoaded(false);
        }
    }

    const reportExcelExport = async () => {
        try {
            const filterSectionData = getFilterSectionData();
            setIsPdfLoading(true);
            const xlColumns = columnDefs.map((col) => {
                return { colHeader: col.headerName, field: col.field, xlCol: col.xlCol }
            });
            const reportTitle = `Maintenance System | S/r No Wise Item History Report`
            const xlConfig = {
                ...excelConfig,
                columns: xlColumns,
                fileName: `S_r_No_Wise_Item_History_Report_${moment(new Date()).format("DD_MMM_YYYY_ddd_HH_mm")}.xlsx`,
                showFilterSection: true,
                filterSectionData,
                workSheetTitle: `S_r_No_Wise_Item_History_Report`,
                headerFooter: {
                    firstHeader: `&L&14&K104FA2 ${reportTitle} &R&B&12 Company Name: ${userData.companyName}`,
                    firstFooter: `&L&12 Report By : ${userData.userFullName}  [ ${userData.branchName} ] &C&12 Report Time :  ${moment(new Date()).format("DD MMM YYYY, ddd, HH:mm")} &R&12 Page: &P of &N`
                },
                sheetHeaderData: [{
                    "caption": "Report Name :",
                    "value": `S/r No Wise Item History Report`,
                    "colSpan": 7
                }, {
                    "caption": "Company Name :",
                    "value": userData.companyName,
                    "colSpan": 6
                }],
            };
            await excelExport.processExcel(xlConfig, tableData);
            setIsPdfLoading(false);
        } catch (err) {
            console.log(err);
            setIsPdfLoading(false);
        }
    }

    const backToScreenView = () => {
        setIsPdfLoaded(false);
    }

    useEffect(() => {
        if (loadData) {
            generateSrNoWiseItemHistoryData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadData]);

    return (
        <>
            {isLoading && <div style={{ width: "100%", textAlign: 'center', marginTop: '10px' }}><Loader /></div>}
            {tableData && !isLoading &&
                <>
                    <div className='report--header--container'>
                        <div key="sih_report_name" className='report--for--heading'>S/r No Wise Item History Report</div>
                        <div key="sih_report_action_container" className="report-export-button--container">
                            {!isPdfLoaded && <>
                                {hasAccess(selectedRolesRights, '4122', adminType) && <div key="sih_xls_btn" id="cssEpExCel" tabIndex={0} className="dashed--btn" onClick={() => reportExcelExport()}> EXPORT AS EXCEL </div>}
                                {hasAccess(selectedRolesRights, '4123', adminType) && <div key="sih_xpdf_btn" id="cssEpAsPDF" tabIndex={0} className="dashed--btn" onClick={() => printReport()}> EXPORT AS PDF </div>}
                                {hasAccess(selectedRolesRights, '4121', adminType) && <div key="sih_prn_btn" id="cssEpExPDF" tabIndex={0} className="dashed--btn" onClick={() => printReport()}> PRINT </div>} </>}
                            {isPdfLoaded && <><div key="sih_backBtn" className="dashed--btn" onClick={() => backToScreenView()}> Back </div> </>}
                            {isPdfLoading && <div key="sih_loading_container" style={{ width: "100px", textAlign: 'center', marginTop: '10px' }}><Loader /></div>}
                        </div>
                    </div>
                    {
                        !isPdfLoaded && !isPdfLoading &&
                        <>
                            <div className='report--sub--header--container'>
                                <div>
                                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Item Support Bus OEM</div>
                                    <div>{srNoWiseItemHistoryFilters.searchVehBrandName || 'All Vehicle OEM'}</div>
                                </div>
                                <div>
                                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Item Support Model Number</div>
                                    <div>{srNoWiseItemHistoryFilters.searchVehModelName || 'All Vehicle Models'}</div>
                                </div>
                                <div >
                                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Category</div>
                                    <div>{srNoWiseItemHistoryFilters.searchCategoryName || 'All Categories'}</div>
                                </div>
                                <div>
                                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Subcategory</div>
                                    <div>{srNoWiseItemHistoryFilters.searchSubCategoryName || 'All Subcategories'}</div>
                                </div>
                                <div >
                                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Brand</div>
                                    <div>{srNoWiseItemHistoryFilters.searchBrandName || 'All Brands'}</div>
                                </div>
                                <div >
                                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Item Name</div>
                                    <div>{srNoWiseItemHistoryFilters.searchItemName}</div>
                                </div>
                                <div >
                                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Sr No</div>
                                    <div>{srNoWiseItemHistoryFilters.searchSerialNo}</div>
                                </div>
                                <div >
                                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Min Service Live In KM</div>
                                    <div>{'0'}</div>
                                </div>
                                <div >
                                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Min Service Live In Days</div>
                                    <div>{'0'}</div>
                                </div>
                            </div>

                            <TableContainer component={Paper} className="jc--scroll jobCrdPreviewModel" style={{ maxHeight: '500px' }} >
                                <Table id="srNoWiseItemHistoryReport" sx={{ minWidth: 1500 }} stickyHeader aria-label="sticky table">
                                    <CommonTableHeaderRow columnDefs={columnDefs} />
                                    <CommonTableBody rows={tableData} tableRowStyle={{}} columnDefs={columnDefs} keyField={'srNo'}
                                        totalRecords={tableData?.length}
                                    />
                                </Table>
                            </TableContainer>
                        </>
                    }
                </>
            }
            {isPdfLoaded && <object id="output" type="application/pdf" width="100%" height="600" title="MTLPL - Maintenance System - Sr No Wise Item History Report" aria-label="MTLPL - Maintenance System - Sr No Wise Item History Report"></object>}
        </>
    );
}
export default SrNoWiseItemHistoryList;